/* The logic core.

   Phase 1 strategy (strangler): the proven logic block from the live app is imported as-is
   (src/core/legacy.block.js, generated by `npm run sync:core`) and exposed here with a growing
   TypeScript surface. New code imports from "@/core" and gets types; nothing new should reach
   into legacy.block.js directly. As functions are re-implemented in TypeScript they move out of
   the legacy block and the tests move with them. */
import { APP as LEGACY } from "./legacy.block.js";
import type { LegacyApp } from "../types/legacy";

export const APP = LEGACY as LegacyApp;

// Typed, named re-exports for the parts new code touches first.
export const {
  LIMITS,
  OCCASIONS,
  TRAILER_DEF,
  SONG_SLOTS,
  validateGuest,
  validateItem,
  validateSlug,
  validateShortWord,
  occasionPreset,
  occasionTemplate,
  buildTrailerPlan,
  trailerSeconds,
  fitTrailer,
  fmtSecs,
  splitCaptions,
  reflowCaptions,
  openerLines,
  stingerLines,
  revealSongs,
  slotName,
  contributorDirectory,
  allKnownEmails,
} = APP;
